import type {AgentSubType, Concept} from 'types';
import { AgentSubTypes} from 'types';

export const isAgentSubType = (
  entity: Concept | undefined,
): entity is AgentSubType => {
  return !!entity && AgentSubTypes.includes(entity as AgentSubType);
};
